import Papa from "papaparse";
import * as XLSX from "xlsx";
export const adjustDateFormat = (date) => {
	let currentDate = date.toLocaleDateString().split("/");
	if (currentDate[0] < 10) {
		currentDate[0] = `0${currentDate[0]}`;
	}
	if (currentDate[1] < 10) {
		currentDate[1] = `0${currentDate[1]}`;
	}
	currentDate = currentDate[2] + "-" + currentDate[0] + "-" + currentDate[1];
	return currentDate;
};

export const convertTimeIntoSeconds = (time) => {
	if (!time) return 0;
	let t = time.split(":");
	let h = parseInt(t[0]) * 3600;
	let m = parseInt(t[1]) * 60;
	return h + m;
};

export const getFormatedTime = (time) => {
	if (!time?.includes(":")) {
		return time;
	}
	let t = time.split(":");
	let h = t[0];
	let m = t[1];

	let ampm = h >= 12 ? "PM" : "AM";
	h = h % 12 || 12;
	h = JSON.stringify(h);
	if (h.length == 1) {
		h = "0" + h;
	}
	if (m.length == 1) {
		m = "0" + m;
	}
	let convertedTime = h + ":" + m + " " + ampm;
	return convertedTime;
};
function s2ab(s) {
	const buf = new ArrayBuffer(s.length);
	const view = new Uint8Array(buf);
	for (let i=0; i<s.length; i++) {
	  view[i] = s.charCodeAt(i) & 0xFF;
	}
	return buf;
  }
  export const exportData = (data, keyTypes, filename, type) => {
	if(type === "date")
	{
			console.log("Type",type)
			console.log("Data",data)
			const workbook = XLSX.utils.book_new();
			
			// Split data by day
			const dataByDay = {};
			keyTypes.forEach((item, index) => {
				const valueSheet = {};
				// const day = date.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' }); // Get day in format MM-DD-YYYY
				const day = item.toString().replaceAll("/", "-");
			
			  if (!dataByDay[day]) {
				dataByDay[day] = [];
			  }
				dataByDay[day] = data[index];
			});
			Object.keys(dataByDay).map(day => {
				const sheetName = day; // Format sheet name as needed
				const sheetData = dataByDay[day];
				const worksheet = XLSX.utils.json_to_sheet(sheetData);
				XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
			})
			
			// Create a file and download it
			const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'binary' });
			const blob = new Blob([s2ab(wbout)], { type: 'application/octet-stream' });
			const url = URL.createObjectURL(blob);
			const pom = document.createElement('a');
			pom.href = url;
			pom.setAttribute('download', `${filename ?? 'epion'}.xlsx`);
			pom.click();
	}
	else if(type === "month")
	{
	console.log("Data",data)
	const workbook = XLSX.utils.book_new();
  
	// Split data by month
	const dataByMonth = {};
	keyTypes.forEach((item, index) => {
		const date = new Date(item);
	  const month = date.getMonth() + 1; // Get month (1-12)
  
	  if (!dataByMonth[month]) {
		dataByMonth[month] = [];
	  }
      console.log("dataByMonth[month]",dataByMonth[month])
	  dataByMonth[month] = data[index];
	});

	console.log(dataByMonth)
  
	// Add each month's data to a separate sheet
	Object.keys(dataByMonth).forEach(month => {
	  const sheetName = `${month < 10 ? '0' : ''}${month}_2023`.replace(/[:\\/?*\[\]]/g, ''); // Format sheet name as needed
	  const sheetData = dataByMonth[month];
	  const worksheet = XLSX.utils.json_to_sheet(sheetData);
	  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
	});
  
	// Create a file and download it
	const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'binary' });
	const blob = new Blob([s2ab(wbout)], { type: 'application/octet-stream' });
	const url = URL.createObjectURL(blob);
	const pom = document.createElement('a');
	pom.href = url;
	pom.setAttribute('download', `${filename ?? 'epion'}.xlsx`);
	pom.click();

}
else{
	console.log("final-data",data)
	var csv = Papa.unparse(data, [
		{
			quotes: false,
			quoteChar: '"',
			escapeChar: '"',
			delimiter: ",",
			header: true,
			newline: "\r\n",
			skipEmptyLines: false,
			columns: null,
		},
	]);
	var blob = new Blob([csv], { type: "text/csv" });
	var url = URL.createObjectURL(blob);
	var pom = document.createElement("a");
	pom.href = url;	
	pom.setAttribute("download", `${filename ?? "epion"}.csv`);
	pom.click();
}
  };
//   export const exportData = (data, filename, type) => {
// 	console.log("Type",type)
// 	console.log("Data",data)
// 	const workbook = XLSX.utils.book_new();
	
// 	// Split data by day
// 	const dataByDay = {};
// 	data.forEach(item => {
// 	  const date = new Date(item.date);
// 	  const day = date.getDate(); // Get day (1-31)
	
// 	  if (!dataByDay[day]) {
// 		dataByDay[day] = [];
// 	  }
// 	  console.log("dataByDay[day]",dataByDay[day])
// 	  dataByDay[day].push(item);
// 	});
	
// 	// Add each day's data to a separate sheet
// 	Object.keys(dataByDay).forEach(day => {
// 	  const sheetName = `${day < 10 ? '0' : ''}${day}_2023`.replace(/[:\\/?*\[\]]/g, ''); // Format sheet name as needed
// 	  const sheetData = dataByDay[day];
// 	  const worksheet = XLSX.utils.json_to_sheet(sheetData);
// 	  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
// 	});
	
// 	// Create a file and download it
// 	const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'binary' });
// 	const blob = new Blob([s2ab(wbout)], { type: 'application/octet-stream' });
// 	const url = URL.createObjectURL(blob);
// 	const pom = document.createElement('a');
// 	pom.href = url;
// 	pom.setAttribute('download', `${filename ?? 'epion'}.xlsx`);
// 	pom.click();
//   };
//   export const exportData = (data, filename) => {
// 	const workbook = XLSX.utils.book_new();
	
// 	// Split data by month
// 	const dataByMonth = {};
// 	data.forEach(item => {
// 	  const date = new Date(item.date);
// 	  const month = date.getMonth() + 1; // Get month (1-12)
	  
// 	  if (!dataByMonth[month]) {
// 		dataByMonth[month] = [];
// 	  }
	  
// 	  dataByMonth[month].push(item);
// 	});
  
// 	// Add each month's data to a separate sheet
// 	Object.keys(dataByMonth).forEach(month => {
// 	  const sheetName = `${month}/1/2023`.replace(/[:\\/?*\[\]]/g, '') // Format sheet name as needed
// 	  const sheetData = dataByMonth[month];
// 	  const worksheet = XLSX.utils.json_to_sheet(sheetData);
// 	  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
// 	});
  
// 	// Create a file and download it
// 	const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'binary' });
// 	const blob = new Blob([s2ab(wbout)], { type: 'application/octet-stream' });
// 	const url = URL.createObjectURL(blob);
// 	const pom = document.createElement('a');
// 	pom.href = url;
// 	pom.setAttribute('download', `${filename ?? 'epion'}.xlsx`);
// 	pom.click();
//   };
// export const exportData = (data, filename) => {
	// console.log("final-data",data)
	// var csv = Papa.unparse(data, [
	// 	{
	// 		quotes: false,
	// 		quoteChar: '"',
	// 		escapeChar: '"',
	// 		delimiter: ",",
	// 		header: true,
	// 		newline: "\r\n",
	// 		skipEmptyLines: false,
	// 		columns: null,
	// 	},
	// ]);
	// var blob = new Blob([csv], { type: "text/csv" });
	// var url = URL.createObjectURL(blob);
	// var pom = document.createElement("a");
	// pom.href = url;
	// pom.setAttribute("download", `${filename ?? "epion"}.csv`);
	// pom.click();
// };

export const convertPdfToByte = (dataURI) => {
	var BASE64_MARKER = ";base64,";
	var base64Index = dataURI.indexOf(BASE64_MARKER) + BASE64_MARKER.length;
	var base64 = dataURI.substring(base64Index);
	var raw = window.atob(base64);
	var rawLength = raw.length;
	var array = new Uint8Array(new ArrayBuffer(rawLength));

	for (var i = 0; i < rawLength; i++) {
		array[i] = raw.charCodeAt(i);
	}
	return array;
};

export const getAgeFromDob = (dob) => {
	const date = new Date(dob);
	const diff = new Date() - date;
	return Math.floor(diff / 3.154e10);
};

export const formatNumber = (e) => {
	if (e >= 1000000000) {
		return (e / 1000000000).toFixed(1).replace(/\.0$/, "") + "B";
	}
	if (e >= 1000000) {
		return (e / 1000000).toFixed(1).replace(/\.0$/, "") + "M";
	}
	if (e >= 1000) {
		return (e / 1000).toFixed(1).replace(/\.0$/, "") + "K";
	}
	return e;
};

export const getInvoiceId = (number) => {
	if (!isNaN(number)) {
		let num = number;
		num = num.toString().padStart(5, "0");
		return `IV-${num}`;
	}
	return;
};


export const generateRandomStr = (length) => {
	let result = '';
	const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
	const charactersLength = characters.length;

	for (let i = 0; i < length; i++ ) {
		result += characters.charAt(Math.floor(Math.random() * charactersLength));
	}

	return result;
}

export const customDateSort = (rowA, rowB, title, isFormatted) => {
	let a = rowA[title];
	let b = rowB[title];
	if (isFormatted) {
		a = new Date(rowA[title]).getTime();
		b = new Date(rowB[title]).getTime();
	} else {
		let splitA = a.split("/");
		a = new Date(splitA[2], splitA[1], splitA[0]).getTime();
		let splitB = b.split("/");
		b = new Date(splitB[2], splitB[1], splitB[0]).getTime();
	}

	if (a > b) {
		return 1;
	}

	if (b > a) {
		return -1;
	}

	return 0;
};

export const customStringSort = (str1, str2, title, isNested) => {
	let s1;
	let s2;

	if (isNested) {
		let value = title.split(".");
		s1 = str1;
		s2 = str2;
		for (let val of value) {
			s1 = s1[val];
			s2 = s2[val];
		}
	} else {
		s1 = str1[title];
		s2 = str2[title];
	}

	if (!s1) return -1;
	if (!s2) return 1;

	console.log(s1);
	const result = s1.localeCompare(s2);

	if (result < 0) {
		return -1;
	} else if (result > 0) {
		return 1;
	} else {
		return 0;
	}
};

function timeToSeconds(time) {
	// Parse the time string into hours, minutes, and AM/PM components
	var match = time.match(/(\d+):(\d+)\s*(AM|PM)/);
	var hours = parseInt(match[1]);
	var minutes = parseInt(match[2]);
	var isPM = match[3] === "PM";

	// Adjust the hours component if the time is in the PM
	if (isPM && hours !== 12) {
		hours += 12;
	}

	if (!isPM && hours == 12) {
		hours = 0;
	}
	// Convert the time to seconds
	var totalSeconds = hours * 3600 + minutes * 60;

	return totalSeconds;
}

export const customTimeSort = (rowA, rowB, title) => {
	const a = timeToSeconds(rowA[title]);
	const b = timeToSeconds(rowB[title]);

	if (a > b) {
		return 1;
	}

	if (b > a) {
		return -1;
	}

	return 0;
};

export const customNumberSort = (rowA, rowB, title) => {
	const a = parseInt(rowA[title]);
	const b = parseInt(rowB[title]);

	if (a > b) {
		return 1;
	}

	if (b > a) {
		return -1;
	}

	return 0;
};

export const customArrayDateSort = (array) => {
	const sortedArray = array.sort((a, b) => {
		return new Date(b) - new Date(a);
	});

	return sortedArray;
}

export const AddOrSubractDays = (startingDate, number, add) => {
	if (add) {
		return new Date(
			startingDate.getFullYear(),
			startingDate.getMonth(),
			startingDate.getDate() + 1,
		);
	} else {
		return new Date(
			startingDate.getFullYear(),
			startingDate.getMonth(),
			startingDate.getDate() - 1,
		);
	}
};

export const base64ToFile = (base64, filename) => {
	const arr = base64.split(",");
	const mime = arr[0].match(/:(.*?);/)[1];
	const bstr = atob(arr[1]);
	let n = bstr.length;
	const u8arr = new Uint8Array(n);

	while (n--) {
		u8arr[n] = bstr.charCodeAt(n);
	}

	return new File([u8arr], filename, { type: mime });
};